<template>
  <v-row justify="center">
    <v-card
      max-width="600"
      :class="$vuetify.breakpoint.smAndDown ? 'px-4 elevation-0 mt-4' : 'mt-8'"
    >
      <v-card-title :class="{ 'px-6 pt-5': $vuetify.breakpoint.mdAndUp }" class="text-h5">
        Sähköinen ostotoimeksianto
      </v-card-title>
      <v-card-text>
        <v-alert type="info" text>
          Sinun täytyy tunnistautua sähköisesti pankkitunnuksillasi,
          jotta voit tarkastella ja allekirjoittaa ostotoimeksiannon.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          text
          color="primary"
          @click="netsLink()"
        >
          Tunnistaudu
          <v-icon>
            chevron_right
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
// import moment from 'moment';
import { apiPost } from '../api';

export default {
  name: 'SignFiles',
  computed: {
    ...mapGetters({
      userDetails: 'userDetails',
    }),
    ...mapState({
      agent: state => state.agent,
      identification: state => state.identification,
    }),
  },
  async mounted() {
    await this.getIdentification();
  },
  methods: {
    ...mapActions({
      getIdentification: 'getIdentification',
    }),
    async netsLink() {
      const state = `buyorder_${this.$route.params.id}_${this.$route.params.companyId}`;

      const response = await apiPost('nets/get-link', { state });

      window.location.href = response.result;
    },
  },
};
</script>
